<template>
    <div :dir="isRTL ? 'rtl' : 'ltr'" :class="{ 'lang-ar': isArabic }">
        <HomeNav />
        <slot />
    <WhatsAppButton />
        <HomeFooter />
    </div>
</template>

<script setup>
import HomeNav from '@/components/pages/Home/Nav.vue';
import WhatsAppButton from '@/components/buttons/WhatsAppButton.vue';
import HomeFooter from '@/components/pages/Home/Footer.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { locale } = useI18n();

const isRTL = computed(() => locale.value === 'ar');
const isArabic = computed(() => locale.value === 'ar');
</script>